module.exports = __webpack_public_path__ + "static/media/googledrive.f096c904.svg";